<app-button
  variant="primary"
  [type]="type"
  [size]="size"
  [startIcon]="startIcon"
  [disabled]="disabled"
  [classes]="classes"
  [dataTestid]="dataTestid"
  (click)="onClick($event)"
>
  {{ labelKey | translate }}
</app-button>
